"use client";

import { useEffect, useState } from "react";

/** Footer clock: `hh:mm City`, value muted, city emphasised. */
export const Clock = ({
  timeZone,
  city,
}: {
  timeZone: string;
  city: string;
}) => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const update = () =>
      setTime(
        new Intl.DateTimeFormat("en-GB", {
          timeZone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }).format(new Date()),
      );
    update();
    const id = setInterval(update, 30_000);
    return () => clearInterval(id);
  }, [timeZone]);

  return (
    <span className="oi-xs" suppressHydrationWarning>
      <span className="oi-muted">{time}</span>{" "}
      <span style={{ fontWeight: 500 }}>{city}</span>
    </span>
  );
};
